import { sanitizeString } from './urlSanitizer';

export default function getUserDefaultTabHash(user) {
  let tabHash = '';
  if (user && user.preferences && user.preferences.defaultEventInspectorTabApp) {
    const defaultTab = user.preferences.defaultEventInspectorTabApp;
    tabHash = `#${sanitizeString(defaultTab.name)}`;
  }
  return tabHash;
}
